module.exports = __webpack_public_path__ + "assets/img/returnBtn-9ea3af0a.png";